'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { Drawer } from '@/components/ui/drawer';
import { useDrawer } from './use-drawer';

export default function GlobalDrawer() {
  const { isOpen, view, placement, customSize, closeDrawer } = useDrawer();
  const pathname = usePathname();
  useEffect(() => {
    closeDrawer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Drawer
      isOpen={isOpen}
      onClose={closeDrawer}
      placement={placement}
      customSize={customSize}
      overlayClassName="bg-gray-900/40 dark:bg-black/60"
      containerClassName="border-l border-gray-200 bg-white shadow-popover dark:bg-gray-100"
    >
      {view}
    </Drawer>
  );
}
